<template>
  <div class="page-wrap">
    <div class="report">
      <div class="report-text">LT预测表</div>
      <lt-filter
        ref="ltfilter"
        @handleEnterData="handleEnterData"
        @refreshTable="refreshTable"
        @downloadFile="downloadFile"
      ></lt-filter>
      <lt-report-table
        ref="reporttable"
        :dataObj="tableData"
        :isEntryData="isEntryData"
      ></lt-report-table>
    </div>
    <div class="record">
      <div class="report-text">检验记录</div>
      <record-table></record-table>
    </div>
    <el-dialog
      title="手动录入"
      :visible.sync="centerDialogVisible"
      width="42%"
      center
      :close-on-click-modal="false"
    >
      <div>
        <enter-data-dialog @successCallback="successCallback" ref="dataDialog"></enter-data-dialog>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button
          type="success"
          style="height: 32px; border-radius: 2px; padding: 0px 9px"
          @click="handerConfirm"
          >查 询</el-button
        >
        <div class="extral">点击查询后输出预测结果</div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ltFilter from "./components/ltFilter.vue";
import ltReportTable from "./components/ltReportTable.vue";
import enterDataDialog from "./components/enterDataDialog.vue";
import recordTable from "./components/recordTable.vue";
import { getItPrediction } from "@/api/api";
export default {
  components: {
    ltFilter,
    ltReportTable,
    enterDataDialog,
    recordTable,
  },

  data() {
    return {
      centerDialogVisible: false,
      tableData: {},
      isEntryData: false,
    };
  },

  computed: {},

  watch: {},

  mounted() {},

  methods: {
    // 录入数据
    handleEnterData() {
      this.centerDialogVisible = true;
      this.$refs.dataDialog?.resetData();
    },
    handerConfirm() {
      this.$refs.dataDialog.saveLtData();
    },
    successCallback(params, data) {
      this.centerDialogVisible = false;
      this.$refs.ltfilter.setFilterParams(params);
      this.tableData = {
        classicPredict: data.classicPredict,
        powerFunctionPredict: data.powerFunctionPredict,
        functionPredict: data.functionPredict,
      };
      this.isEntryData = true;
    },
    // 下载Excel
    downloadFile() {
      this.$refs.reporttable.downLoadFileToExcel();
    },
    refreshTable(params) {
      getItPrediction({ data: params }).then((res) => {
        this.tableData = {
          classicPredict: res.classicPredict,
          powerFunctionPredict: res.powerFunctionPredict,
          functionPredict: res.functionPredict,
        };
      });
      this.isEntryData = false;
    },
  },
};
</script>

<style lang="less" scoped>
.page-wrap {
  padding: 16px;
  margin-bottom: 24px;
  .report-text {
    padding: 16px 16px 6px 16px;
    font-size: 15px;
    color: rgba(0, 0, 0, 0.85);
    font-weight: bold;
  }
  .report {
    background: white;
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
    padding-bottom: 20px;
  }
  .record {
    background: white;
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
    margin-top: 16px;
  }
  .extral {
    color: #777;
    margin-top: 4px;
    font-size: 12px;
  }
  /deep/ .el-dialog__footer {
    text-align: end;
  }
}
</style>
